interface GradientButtonProps {
  text: string;
  type: "button" | "submit" | "reset";
  disabled?: boolean;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const GradientButton: React.FC<GradientButtonProps> = ({
  text,
  type,
  disabled = false,
  className = "",
  onClick,
}) => {
  return (
    <button
      type={type}
      className={`relative w-full md:w-auto px-6 py-3 min-w-[130px] md:max-w-[230px] lg:max-w-[230px] rounded-full text-white font-semibold border-none ring-2 ring-transparent overflow-hidden group transition-all duration-300 ease-in-out flex items-center justify-center ${className}`}
      disabled={disabled}
      onClick={onClick}
    >
      <span className="absolute inset-0 bg-gradient-to-r from-custom-teal via-custom-purple to-custom-dark-purple transition-all duration-300 ease-in-out group-hover:bg-gradient-custom-hover" />
      <span className="relative font-bold text-sm md:text-base">{text}</span>
    </button>
  );
};

export default GradientButton;
